function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#Phone_landline_svg__clip0)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.626 2.994a1.5 1.5 0 01.151.026A10.5 10.5 0 0148 13.27v1.78c0 2.484-2.016 4.5-4.5 4.5H36a4.501 4.501 0 01-4.5-4.5 1.5 1.5 0 00-1.5-1.5H18a1.5 1.5 0 00-1.5 1.5c0 2.484-2.016 4.5-4.5 4.5H4.5a4.501 4.501 0 01-4.5-4.5v-1.78c0 .001 0 0 0 0A10.5 10.5 0 018.222 3.017c.05-.011.101-.02.152-.026a82.688 82.688 0 0131.252.004zm-.481 2.963a79.688 79.688 0 00-30.36.008A7.5 7.5 0 003 13.269v1.781a1.5 1.5 0 001.5 1.5H12a1.5 1.5 0 001.5-1.5c0-2.484 2.016-4.5 4.5-4.5h12c2.484 0 4.5 2.016 4.5 4.5a1.5 1.5 0 001.5 1.5h7.5a1.5 1.5 0 001.5-1.5v-1.78a7.5 7.5 0 00-5.784-7.301 1.502 1.502 0 01-.071-.012zM7.5 22.55a1.5 1.5 0 011.5 1.5v12a7.5 7.5 0 007.5 7.5h15a7.5 7.5 0 007.5-7.5v-12a1.5 1.5 0 013 0v12c0 5.798-4.702 10.5-10.5 10.5h-15c-5.798 0-10.5-4.702-10.5-10.5v-12a1.5 1.5 0 011.5-1.5z"
}), React.createElement("path", {
  d: "M15.75 27.05a.75.75 0 100 1.5.75.75 0 000-1.5z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5 27.8a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm2.25.75a.75.75 0 100-1.5.75.75 0 000 1.5z"
}), React.createElement("path", {
  d: "M24 27.05a.75.75 0 100 1.5.75.75 0 000-1.5z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.75 27.8a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm2.25.75a.75.75 0 100-1.5.75.75 0 000 1.5z"
}), React.createElement("path", {
  d: "M32.25 27.05a.75.75 0 100 1.5.75.75 0 000-1.5z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30 27.8a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm2.25.75a.75.75 0 100-1.5.75.75 0 000 1.5z"
}), React.createElement("path", {
  d: "M15.75 34.55a.75.75 0 100 1.5.75.75 0 000-1.5z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5 35.3a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm2.25.75a.75.75 0 100-1.5.75.75 0 000 1.5z"
}), React.createElement("path", {
  d: "M24 34.55a.75.75 0 100 1.5.75.75 0 000-1.5z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.75 35.3a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm2.25.75a.75.75 0 100-1.5.75.75 0 000 1.5z"
}), React.createElement("path", {
  d: "M32.25 34.55a.75.75 0 100 1.5.75.75 0 000-1.5z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30 35.3a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm2.25.75a.75.75 0 100-1.5.75.75 0 000 1.5z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "Phone_landline_svg__clip0"
}, React.createElement("path", {
  d: "M0 0h48v48H0V0z"
})));

function SvgPhoneLandline(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
}

export default SvgPhoneLandline;